export const locales = ["ja", "en"] as const;

export type Locale = (typeof locales)[number];

export const defaultLocale: Locale = "en";

export function isLocale(value: string | undefined): value is Locale {
	return locales.includes(value as Locale);
}

export function localeLabel(locale: Locale): string {
	return locale === "ja" ? "日本語" : "English";
}

export function localeHtmlLang(locale: Locale): string {
	return locale === "ja" ? "ja" : "en";
}

export function localeDateLocale(locale: Locale): string {
	return locale === "ja" ? "ja-JP" : "en-US";
}
